export default __webpack_public_path__ + "static/media/ic_flag_en.9a67c937.svg";